<template>
  <div>
    <vx-card class="">
      <div>
        <!-- back button -->

        <!-- input -->
        <!-- <div class="mt-4">
        <div>
          <label class=" col-form-label form-control-label">Title</label>

          <base-input placeholder="Title"></base-input>
        </div>

        <div>
          <label class=" col-form-label form-control-label">Sub Title</label>

          <base-input placeholder="Sub Title "></base-input>
        </div>

        <div>
          <label class=" col-form-label form-control-label">Description</label>

          <textarea
            class="form-control"
            placeholder="Description"
            id="exampleFormControlTextarea3"
            rows="3"
          ></textarea>
        </div>

        <div>
          <label class=" col-form-label form-control-label">Image Upload</label>

          <b-form>
            <b-form-file
              @change="filesChange"
              placeholder="Select file"
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </b-form>
        </div>

        <div>
          <label class=" col-form-label form-control-label">Tags</label>

          <base-input placeholder="Tags "></base-input>
        </div>
      </div> -->

        <div class="mb-4 flex items-center w-full">
          <div class="w-1/2 pr-2">
            <label class="col-form-label form-control-label">Author Name</label>

            <base-input
              v-model="aname"
              placeholder="Enter Author Name"
              class="cust-mb0"
            ></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class="col-form-label form-control-label">Course Name</label>

            <base-input
              v-model="cname"
              placeholder="Enter Course Name"
              class="cust-mb0"
            ></base-input>
          </div>
        </div>

        <div class="flex items-center">
          <div class="w-1/2 pr-2">
            <label class="col-form-label form-control-label">Phone No.</label>

            <base-input
              v-model="phone"
              placeholder="Enter Phone no."
            ></base-input>
          </div>
          <div class="w-1/2 pl-2">
            <label class="col-form-label form-control-label">Email ID</label>

            <base-input
              v-model="email"
              placeholder="Enter EmailID"
            ></base-input>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class="col-form-label form-control-label">Signature</label>
            <small class="pl-2">
              ( Accepted File Formats: GIF, JPG, PNG, BMP, Max file size 200KB )
            </small>

            <b-form>
              <b-form-file
                @change="filesChange"
                v-model="image"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form>
          </div>

          <div class="w-1/2 pl-2">
            <label class="col-form-label form-control-label">Curriculum</label>

            <base-input
              v-model="text"
              placeholder="Enter Curriculum"
              class="cust-mb0"
            ></base-input>
          </div>
        </div>

        <!-- <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Course Reader Level</label
            >

            <base-input
              placeholder="Enter Course Reader Level"
              class="mb-0"
            ></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Course Download Allowed</label
            >

            <base-input
              placeholder="Enter Course Download Allowed"
              class="mb-0"
            ></base-input>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Signature on Certificate</label
            >

            <base-input
              placeholder="Enter Signature on Certificate"
              class="mb-0"
            ></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label">INR Price</label>

            <base-input placeholder="Enter INR Price" class="mb-0"></base-input>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Signature on Certificate</label
            >

            <base-input
              placeholder="Enter Signature on Certificate"
              class="mb-0"
            ></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label">INR Price</label>

            <base-input placeholder="Enter INR Price" class="mb-0"></base-input>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label">USD Price</label>

            <base-input placeholder="Enter USD Price" class="mb-0"></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Set Course Expiry in Days
            </label>

            <base-input
              placeholder="Enter Set Course Expiry in Days"
              class="mb-0"
            ></base-input>
          </div>
        </div> -->
        <div class="mb-4 pt-4 flex items-center">
          <base-button icon type="default" @click="addAuthor(aname)">
            <span class="btn-inner--text">Submit</span>
          </base-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import "../../../scss/Index.scss";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      showPlan: false,
      aname: "",
      cname: "",
      phone: "",
      email: "",
      image: "",
      text: "",
    };
  },
  methods: {
    async addAuthor(name) {
      // console.log(this.aname);
      const { data } = await this.$store.dispatch(
        "Authors/createAuthorDetails",
        {
          name: this.aname,
          category: this.cname,
          phone: this.phone,
          email: this.email,
        }
      );
    },
  },
  computed: {
    ...mapState("posts", {
      currentPage: "currentPage",
      type: "type",
    }),
  },
};
</script>
